export class NumberUtilities {

    public static pad2(number: any) {
        return (number < 10 ? "0" : "") + number;
    }

    public static round(number: number, precision: number): number {

        if (!number) {
            return number;
        }

        if (typeof number !== 'number') {
            throw new TypeError('Expected value to be a number');
        }

        if (precision > 14) {
            return number;
        }

        if (!Number.isInteger(precision)) {
            throw new TypeError('Expected precision to be an integer');
        }

        const isRoundingAndNegative = number < 0;
        if (isRoundingAndNegative) {
            number = Math.abs(number);
        }

        const power = 10 ** precision;

        let result = Math.round(Number((number * power).toPrecision(15))) / power;

        if (isRoundingAndNegative) {
            result = -result;
        }

        //if -0 then just set it to 0.
        if (Math.abs(result) < Number.EPSILON) {
            result = 0;
        }

        return result;
    }
}
